import { Navigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../Moduels/Context/AuthContext";
import { useOrgProfile } from "../../Moduels/Context/OrgProfileContext";
import BrixigoPageLoader from "../common/BrixigoPageLoader";

const ALLOWED_WITHOUT_PROFILE = ["/onboarding/org-profile", "/login"];

/**
 * Shows org profile wizard on first admin login when profile is incomplete.
 * After skip, admins can browse the app; dashboard banner reminds them to finish.
 */
export default function OrgProfileGate({ children }) {
  const location = useLocation();
  const { loading: authLoading } = useContext(AuthContext);
  const ctx = useOrgProfile();

  if (authLoading || ctx?.status?.loading) {
    return <BrixigoPageLoader message="Loading organisation…" overlay />;
  }

  if (!ctx) return children;

  const path = location.pathname;

  if (ctx.noOrganisation) {
    return (
      <div className="op-block-page">
        <div className="op-block-card">
          <h1>No organisation linked</h1>
          <p>Your account is not linked to an organisation. Contact your administrator.</p>
        </div>
      </div>
    );
  }

  if (ctx.mustCompleteWizard && !ALLOWED_WITHOUT_PROFILE.includes(path)) {
    return <Navigate to="/onboarding/org-profile" replace state={{ from: path }} />;
  }

  return children;
}
